import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { CustomerServiceService } from "src/app/customer/customer-service.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SharedService } from "../shared.service";
import { RetriveAccountComponent } from "../retrive-account/retrive-account.component";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  MatDialogref: MatDialogRef<RetriveAccountComponent>;

  login: boolean = true;
  retrieve_acc: boolean = false;
  otp: boolean = false;
  signUp: boolean = false;
  gst: boolean = false;
  profileImg: boolean = true;
  mobile: any;
  loginForm!: FormGroup;
  signupForm!: FormGroup;
  otpForm!: FormGroup;
  GSTForm!: FormGroup;
  loginResponse: any;
  verifyData: any;
  errorMessage: any;
  code: any;
  otpWrongErrorMsg: boolean = false;
  file: any = "";
  // profileImage: any = "";
  token: any;
  isVerifyingOtp: boolean = false;
  isGstVerifying: boolean = false;
  isGstVerified: boolean = false;
  gstVerificationData: any = null;
  loading: boolean = false;
  seconds: any;
  maticon: boolean = false;
  // Start with an initial value of 20 seconds
  TIME_LIMIT = 30;
  profilePic: any;
  userName: any;
  profileImage: string | null = null;
  // Initially, no time has passed, but this will count up
  // and subtract from the TIME_LIMIT
  timePassed = 0;
  timeLeft = this.TIME_LIMIT;
  clearTimeInterval: any;
  response_code: boolean = false;
  corporatetoken: any;
  COLOR_CODES = {
    info: {
      color: "green",
    },
  };
  truckDetails: any;
  message: any;
  constructor(
    private matDialogref: MatDialogRef<LoginComponent>,
    private formBuilder: FormBuilder,
    private services: CustomerServiceService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private shrdSrvce: SharedService,
    private matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token") || localStorage.getItem("token") || "";
    this.corporatetoken = sessionStorage.getItem("corporate_token") || localStorage.getItem("corporate_token");

    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    if (this.corporatetoken == null) {
      this.router.navigateByUrl("/");
    }
    this.loginForm = this.formBuilder.group({
      mobile: new FormControl(
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{10}$"),
        ])
      ),
    });
    this.signupForm = this.formBuilder.group({
      username: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9\\s]+$"),
        ]),
      ],
      mobile: new FormControl(null, Validators.compose([Validators.required])),
      email: [
        "",
        Validators.compose([
          // Validators.required,
          Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/),
        ]),
      ],
    });
    this.otpForm = this.formBuilder.group({
      code: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^\d{6}$/),
        ]),
      ],
    });
    this.GSTForm = this.formBuilder.group({
      gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],
      designation: [""],
      company_name: [""],
      profile_pic: [""],
    });
    const interval_id = window.setInterval(function () {},
    Number.MAX_SAFE_INTEGER);
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }
  public get contactFormControl() {
    return this.GSTForm.controls;
  }
  sendOTP() {
    if (this.loginForm.valid) {
      const loginData = {
        mobile: this.loginForm.value.mobile,
        user_type: "customer",
      };
      if (environment.base_url === `${environment.base_url}`) {
        this.response_code = true;
      } else {
        this.response_code = false;
      }
      this.loading = true;
      this.services.customerLogin(loginData).subscribe(
        (response: any) => {
          this.loginResponse = response;
          this.login = false;
          this.otp = true;
          this.loading = true;
        },
        (error: any) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          this.matDialogref.close();
          if (error.error.data.new_user == true) {
            this.login = false;
            this.otp = true;
            this.loading = true;
            this.loginResponse = error.error.data;
          } else {
            this.message = error.error.message;
            this.retrieve_acc = true;
            this.login = false;
            this.otp = false;
            this.loading = false;
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        }
      );
    }
  }
  clear() {
    this.matDialogref.close();
  }

  verifyOtp(code: string) {
    if (this.isVerifyingOtp) {
      return;
    }
    this.isVerifyingOtp = true;
    const otpObj = {
      code: code,
      mobile: this.loginResponse.mobile,
      user_type: "customer",
    };
    this.services.OTPVerify(otpObj, this.loginResponse._id).subscribe(
      (response: any) => {
        this.isVerifyingOtp = false;
        this.verifyData = response.data;
        this.errorMessage = response.message;
        if (response.auth) {
          this.token = response.auth;
          sessionStorage.setItem("token", response.auth);
        }
        if (this.verifyData.user_type === "driver") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
          this.matDialogref.close();
          this.snackBar.open("Please enter registerd mobile number", "Fail", {
            duration: 5000,
          });
          return;
        }
        if (this.verifyData.new_user == true) {
          this.login = false;
          this.otp = false;
          this.signUp = true;
          this.snackBar.open(this.errorMessage, "Info", {
            duration: 5000,
          });
        } else {
          this.login = false;
          this.otp = false;
          if (response.data.user_type === "corporate") {
            sessionStorage.setItem("corporate_token", response.auth);
            sessionStorage.setItem("corporateUserName", this.verifyData.username);
            sessionStorage.setItem(
              "corporateProfilePic",
              this.verifyData.profile_pic
            );
            sessionStorage.setItem("corporate_user_type", this.verifyData.user_type);
            sessionStorage.setItem("user_type", this.verifyData.user_type);
          }
          if (response.data.user_type === "customer") {
            sessionStorage.setItem("token", response.auth);
            sessionStorage.setItem("userName", this.verifyData.username);
            sessionStorage.setItem("ProfilePic", this.verifyData.profile_pic);
            sessionStorage.setItem("user_type", this.verifyData.user_type);
          }

          this.shrdSrvce.notifyAuthChange();
          this.matDialogref.close({ success: true, user_type: response.data.user_type });
          this.snackBar.open("Login Successful", "Success", {
            duration: 5000,
          });

          if (this.verifyData.user_type === "corporate") {
            this.router.navigate(["/corporate"]);
          } else if (this.data?.routeFrom == "ReserveAvailableTrip") {
            if (this.data?.fullResult) {
              this.shrdSrvce.updateSearchDetails(this.data.fullResult);
              const pickup = this.data.fullResult.searchData?.completePickUpAddress?.formatted_address;
              const drop = this.data.fullResult.searchData?.completeDropAddress?.formatted_address;
              if (pickup && drop && typeof pickup === 'string' && typeof drop === 'string' && pickup.trim() !== "" && drop.trim() !== "") {
                this.router.navigate(["/"]);
              } else {
                this.snackBar.open(
                  "Please enter both Pickup and Drop-off locations to reserve this trip.",
                  "Close",
                  { duration: 3000 }
                );
              }
            } else {
              this.router.navigate(["/"]);
            }
            this.getProfile();
          } else if (this.data?.routeFrom == "ReserveTrip") {
            if (this.data?.fullResult) {
              this.shrdSrvce.updateSearchDetails(this.data.fullResult);
              const pickup = this.data.fullResult.searchData?.completePickUpAddress?.formatted_address;
              const drop = this.data.fullResult.searchData?.completeDropAddress?.formatted_address;
              if (pickup && drop && typeof pickup === 'string' && typeof drop === 'string' && pickup.trim() !== "" && drop.trim() !== "") {
                this.router.navigate(["/truck-details"]);
              } else {
                this.snackBar.open(
                  "Please enter both Pickup and Drop-off locations to reserve this trip.",
                  "Close",
                  { duration: 3000 }
                );
              }
            } else {
              this.router.navigate(["/truck-details"]);
            }
            this.getProfile();
          } else if (this.data?.routeFrom == "Search") {
            this.searchTruckDetails(this.data.tripSearchData);
            this.getProfile();
          } else if (this.data?.routeFrom == "TruckDetails" || this.data?.routeFrom == "header" || this.data?.routeFrom == "login") {
            this.getProfile();
          } else {
            this.router.navigate(["/truck-details"]);
            this.getProfile();
          }
        }
      },
      (error) => {
        this.isVerifyingOtp = false;
        if (error.status == 400) {
          this.otpWrongErrorMsg = true;
        }
      }
    );
  }

  public GetProfileDetails() {
    this.token = localStorage.getItem("token");
    this.corporatetoken = localStorage.getItem("corporate_token");
    this.userName = localStorage.getItem("userName");
    this.profilePic = localStorage.getItem("ProfilePic");
  }
  searchTruckDetails(tripSearchData: any) {
    this.token = localStorage.getItem("token");
    this.services
      .SearchTruckDetails(tripSearchData, this.token)
      .subscribe((response: any) => {
        if (response.status === 201) {
          this.truckDetails = response.body.data;
          tripSearchData["truckweight"] = tripSearchData.truckWeight.find(
            (ele: any) => {
              return ele._id === tripSearchData.truck_type;
            }
          );
          tripSearchData["truckDetails"] = this.truckDetails;
          tripSearchData["truckCategory"] = {
            id: tripSearchData.truck_category,
            name: tripSearchData.truckCategory.find((ele: any) => {
              if (ele._id === tripSearchData.truck_category) {
                return ele.truck_category_name;
              }
            }),
          };
          (tripSearchData["completePickUpAddress"] =
            tripSearchData.completePickUpAddress),
            (tripSearchData["completeDropAddress"] =
              tripSearchData.completeDropAddress),
            sessionStorage.setItem(
              "searchData",
              JSON.stringify(tripSearchData)
            );
          const searchdata = {
            searchData: tripSearchData,
            data: this.truckDetails,
            truckweight: tripSearchData.truckWeight.find((ele: any) => {
              return ele._id === tripSearchData.truck_type;
            }),
            truckCategory: tripSearchData["truckCategory"],
          };
          this.shrdSrvce.updateSearchDetails(searchdata);
          this.router.navigate(["/truck-details"]);
        }
      });
  }

  onGstChange(): void {
    if (this.isGstVerified) {
      this.isGstVerified = false;
      this.gstVerificationData = null;
    }
  }

  editGst(): void {
    this.isGstVerified = false;
    this.gstVerificationData = null;
    this.snackBar.open("You can now edit GST. Please verify again once modified.", "OK", {
      duration: 4000,
    });
  }

  verifyGST(rawGst?: any, callback?: () => void): void {
    const gstValue = typeof rawGst === "string" ? rawGst : this.GSTForm.controls["gst"]?.value;
    if (!gstValue || typeof gstValue !== "string" || gstValue.trim() === "") {
      this.snackBar.open("Please enter a GSTIN to verify", "OK", {
        duration: 4000,
      });
      this.GSTForm.controls["gst"]?.markAsTouched();
      return;
    }

    const cleanGst = gstValue.replace(/[^A-Za-z0-9]/g, "").trim().toUpperCase();
    if (cleanGst.length !== 15) {
      this.snackBar.open("GSTIN must be exactly 15 alphanumeric characters", "OK", {
        duration: 4000,
      });
      return;
    }

    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gstRegex.test(cleanGst)) {
      this.snackBar.open("Please enter a valid 15-digit GST format (e.g. 36AAECS9130L1Z1)", "OK", {
        duration: 4000,
      });
      return;
    }

    this.token = this.token || sessionStorage.getItem("token") || "";
    this.isGstVerifying = true;
    this.services.verifyGST(cleanGst, this.token).subscribe({
      next: (response: any) => {
        this.isGstVerifying = false;
        let resData = response.body?.data || response.body;

        while (
          resData?.data &&
          typeof resData.data === "object" &&
          !resData.lgnm &&
          !resData.tradeNam &&
          !Array.isArray(resData.data)
        ) {
          resData = resData.data;
        }

        if (
          response.body?.success === false ||
          response.body?.gst_verified === false ||
          resData?.error === true ||
          resData?.error === "true" ||
          resData?.code === "400" ||
          resData?.code === 5004 ||
          resData?.code === "5004"
        ) {
          const errMsg =
            response.body?.message ||
            (typeof resData?.data === "string" ? resData.data : "") ||
            resData?.message ||
            "Invalid or unverified GSTIN.";
          this.snackBar.open(errMsg, "Fail", { duration: 5000 });
          this.isGstVerified = false;
          return;
        }

        const taxpayerList = Array.isArray(resData?.data)
          ? resData.data
          : Array.isArray(resData)
          ? resData
          : null;
        const taxpayer = taxpayerList
          ? taxpayerList[0]
          : resData?.data || resData;

        if (
          !taxpayer ||
          (!taxpayer.lgnm && !taxpayer.tradeNam && !taxpayer.gstin)
        ) {
          this.snackBar.open("GST details not found for this GSTIN.", "Fail", {
            duration: 5000,
          });
          this.isGstVerified = false;
          return;
        }

        this.isGstVerified = true;
        this.gstVerificationData = taxpayer;
        this.GSTForm.controls['gst'].setValue(cleanGst);

        // Auto-fill company name
        const businessName = (taxpayer.tradeNam || taxpayer.lgnm || "").trim();
        if (businessName) {
          this.GSTForm.controls['company_name'].setValue(businessName);
        }

        const nameMsg = businessName ? ` (${businessName})` : "";
        this.snackBar.open(`GSTIN Verified Successfully${nameMsg}!`, "Success", {
          duration: 5000,
        });

        if (callback) {
          callback();
        }
      },
      error: (error: any) => {
        this.isGstVerifying = false;
        this.isGstVerified = false;
        const errObj = error.error;
        const errMsg =
          errObj?.message ||
          (typeof errObj?.data === "string" ? errObj.data : "") ||
          (typeof errObj?.data?.data === "string" ? errObj.data.data : "") ||
          errObj?.data?.message ||
          error.message ||
          "GST verification failed. Please try again.";
        this.snackBar.open(errMsg, "Fail", { duration: 5000 });
      },
    });
  }

  Register(num: number) {
    const rawGst = (this.GSTForm.controls['gst']?.value || "").trim().toUpperCase();

    // If GST is provided and 15 chars, but not yet verified:
    if (num !== 2 && rawGst && rawGst.length === 15 && !this.isGstVerified) {
      if (this.isGstVerifying) return;
      this.verifyGST(rawGst, () => {
        this.executeRegister(num);
      });
      return;
    }

    if (num !== 2 && rawGst && rawGst.length > 0 && rawGst.length !== 15) {
      this.snackBar.open("Please enter a valid 15-digit GSTIN or leave it blank", "OK", {
        duration: 4000,
      });
      return;
    }

    this.executeRegister(num);
  }

  executeRegister(num: number) {
    let registerObj = null;
    const rawGst = (this.GSTForm.controls['gst']?.value || "").trim().toUpperCase();
    const panFromGst = rawGst.length === 15 ? rawGst.substring(2, 12) : "";

    if (num === 2) {
      registerObj = {
        username: this.signupForm.value.username,
        mobile: this.signupForm.value.mobile,
        email: this.signupForm.value.email,
        profile_pic: this.profileImage,
      };
    } else {
      registerObj = {
        username: this.signupForm.value.username,
        mobile: this.signupForm.value.mobile,
        email: this.signupForm.value.email,
        company_name: this.GSTForm.value.company_name,
        gst: rawGst,
        gst_verified: !!this.isGstVerified,
        pan: panFromGst,
        designation: this.GSTForm.value.designation,
        profile_pic: this.profileImage,
      };
    }

    this.services.newRegister(registerObj, this.verifyData._id).subscribe(
      (response: any) => {
        if (response.status == 201 || response.status == 200) {
          sessionStorage.setItem("token", response.body.auth);
          sessionStorage.setItem("ProfilePic", this.profileImage || "");
          sessionStorage.setItem("userName", response.body.data.username);
          sessionStorage.setItem("user_type", response.body.data.user_type || "customer");
          this.shrdSrvce.notifyAuthChange();
          this.matDialogref.close({ success: true, user_type: response.body.data.user_type || "customer" });

          if (this.data?.routeFrom == "ReserveTrip") {
            if (this.data?.fullResult) {
              this.shrdSrvce.updateSearchDetails(this.data.fullResult);
              const pickup = this.data.fullResult.searchData?.completePickUpAddress?.formatted_address;
              const drop = this.data.fullResult.searchData?.completeDropAddress?.formatted_address;
              if (pickup && drop && typeof pickup === 'string' && typeof drop === 'string' && pickup.trim() !== "" && drop.trim() !== "") {
                this.router.navigateByUrl("/truck-details");
              } else {
                this.snackBar.open(
                  "Please enter both Pickup and Drop-off locations to reserve this trip.",
                  "Close",
                  { duration: 3000 }
                );
              }
            } else {
              this.router.navigateByUrl("/truck-details");
            }
          } else if (this.data?.routeFrom == "Search") {
            this.searchTruckDetails(this.data.tripSearchData);
            this.router.navigateByUrl("/truck-details");
          } else {
            this.router.navigate(["/"]);
          }
          this.getProfile();
          this.snackBar.open("Registration Successful", "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  Next() {
    if (this.signupForm.valid) {
      this.signUp = false;
      this.gst = true;
    } else {
      this.signupForm.markAllAsTouched();
    }
  }
  onOtpChange(code: string): void {
    if (code.length == 4) {
      this.verifyOtp(code);
    }
  }
  skip() {
    this.Register(2);
  }
  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.profileImage = response.body.image_link;
        this.profileImg = false;
      }
    });
  }
  resendOTP() {
    const loginData = {
      mobile: this.loginForm.value.mobile,
      user_type: "customer",
    };
    this.services.customerLogin(loginData).subscribe((response: any) => {
      this.loginResponse = response;
      this.login = false;
      this.otp = true;
    });
  }

  restoreAccount() {
    const userType = "active";
    this.services
      .accountRestore(userType, this.loginForm.value.mobile)
      .subscribe((response: any) => {
        this.login = true;
        this.retrieve_acc = false;
        this.snackBar.open(
          "Your account has been activated successfully",
          "Success",
          {
            duration: 5000,
          }
        );
      });
  }
  newLogin() {
    this.login = true;
    this.retrieve_acc = false;
  }
  public getProfile(): void {
    let token = sessionStorage.getItem("token") || sessionStorage.getItem("corporate_token") || localStorage.getItem("token");
    if (token) {
      this.services.GetProfile(token).subscribe((response: any) => {
        if (response && response.body && response.body.data) {
          const uName = response.body.data.username || response.body.data.name;
          if (uName) {
            sessionStorage.setItem("userName", uName);
          }
          if (response.body.data.profile_pic) {
            sessionStorage.setItem("ProfilePic", response.body.data.profile_pic);
          }
          this.shrdSrvce.notifyAuthChange();
        }
      });
    }
  }
  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
